import React, { Component, Fragment, isValidElement } from 'react';
import { BulletTrail, InlineImage, Input } from '@philips-internal/oswald-ui-components';
import { Placement } from '@philips-internal/oswald-ui-constants';
import { classNames, isContentfulString, isFunction, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CancelIcon } from '../../../resources/assets/cancel-md-dark.svg';
import { ReactComponent as NavigationIcon } from '../../../resources/assets/DLS_Navigation.svg';
import { ReactComponent as DefaultModuleIcon } from '../../../resources/assets/DLS_Placeholder.svg';
import { ReactComponent as MagnifierIcon } from '../../../resources/assets/magnifier.svg';
import { isApplicationModule } from '../../application-module-registry.js';
import { foundationContext } from '../../index.js';
import './module-selector.css';
import './module-selector-spatial-desktop.css';
class ModuleSelectorSpatialDesktop extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            currentPage: 0,
        };
        this.onBackClick = () => {
            this.setState(prevState => ({ currentPage: prevState.currentPage - 1 }));
        };
        this.onNextClick = () => {
            this.setState(prevState => ({ currentPage: prevState.currentPage + 1 }));
        };
        this.onSearchChange = (event) => {
            const { onSearchChange } = this.props;
            if (isFunction(onSearchChange)) {
                onSearchChange(event);
            }
        };
    }
    componentDidUpdate(prevProps) {
        const { searchTerm } = this.props;
        const { currentPage } = this.state;
        if (currentPage > 0 && searchTerm !== prevProps.searchTerm) {
            this.setState({ currentPage: 0 });
        }
    }
    renderInnerModuleSpatialDesktop() {
        const { selectedModuleGroup } = this.props;
        if (selectedModuleGroup) {
            return (React.createElement(Fragment, null,
                this.renderTabSpatialDesktop(selectedModuleGroup.prettyName),
                this.renderModulesSpatialDesktop(selectedModuleGroup.modules)));
        }
        return (this.renderModulesAreaSpatialDesktop());
    }
    renderTabSpatialDesktop(name) {
        const { selectedModuleGroup } = this.props;
        if (isContentfulString(name) && !selectedModuleGroup?.modules.length) {
            return null;
        }
        const { onModuleGroupBackClick } = this.props;
        return (React.createElement("div", { className: "c-module-selector-spatial-desktop__title-wrapper" },
            React.createElement(NavigationIcon, { className: "c-module-selector-spatial-desktop__title-icon", onClick: onModuleGroupBackClick }),
            React.createElement("div", { className: "c-module-selector-spatial-desktop__modules-title" }, name)));
    }
    renderModulesAreaSpatialDesktop() {
        const { pages } = this.props;
        const { currentPage } = this.state;
        const totalPages = pages.length;
        return (React.createElement(Fragment, null,
            this.renderBackArrow(currentPage, totalPages),
            this.renderModulesSpatialDesktop(pages[currentPage]),
            this.renderNextArrow(currentPage, totalPages),
            this.renderPaginator(currentPage, totalPages)));
    }
    renderIcon(icon) {
        const { showIconsOnSpatialDesktop } = this.props;
        if (!showIconsOnSpatialDesktop) {
            return null;
        }
        let content = React.createElement(DefaultModuleIcon, null);
        if (isContentfulString(icon)) {
            content = React.createElement(InlineImage, { src: icon });
        }
        if (isValidElement(icon)) {
            content = icon;
        }
        return (React.createElement("div", { className: "c-module-selector-spatial-desktop__module-icon" }, content));
    }
    renderModulesSpatialDesktop(modules) {
        const { onModuleClick } = this.props;
        if (!modules || modules.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: "c-module-selector-spatial-desktop__modules" }, modules.map((module, index) => {
            const className = classNames({
                'c-module-selector-spatial-desktop__module-wrapper': true,
                'c-module-selector-spatial-desktop__module-wrapper--disabled': isApplicationModule(module) && Boolean(module.disabled),
            });
            return (React.createElement("div", { className: className, key: `${module.id}-${index}` },
                React.createElement("div", { className: "c-module-selector-spatial-desktop__module", onClick: trigger(onModuleClick, module) },
                    this.renderIcon(module.icon),
                    React.createElement("div", { className: "c-module-selector-spatial-desktop__module-name" }, module.prettyName))));
        })));
    }
    renderBackArrow(currentPage, totalPages) {
        if (totalPages <= 1 || currentPage === 0) {
            return null;
        }
        return (React.createElement(NavigationIcon, { className: "c-module-selector-spatial-desktop__navigation-icon--back", onClick: this.onBackClick }));
    }
    renderNextArrow(currentPage, totalPages) {
        if (totalPages <= 1 || currentPage == (totalPages - 1)) {
            return null;
        }
        return (React.createElement(NavigationIcon, { className: "c-module-selector-spatial-desktop__navigation-icon--next", onClick: this.onNextClick }));
    }
    renderPaginator(currentPage, totalPages) {
        if (totalPages <= 1) {
            return null;
        }
        return (React.createElement("div", { className: "c-module-selector-spatial-desktop__trail-wrapper" },
            React.createElement(BulletTrail, { length: totalPages, page: currentPage })));
    }
    renderSearchSpatialDesktop() {
        const { onClearSearch, onSearchChange, searchTerm, selectedModuleGroup } = this.props;
        if (selectedModuleGroup) {
            return null;
        }
        const searchExpression = foundationContext.getModuleSearchExpression();
        const { externalAction, externalActionPlacement } = searchTerm.length
            ? { externalAction: React.createElement(CancelIcon, { className: "c-module-selector__cancel-icon", onClick: onClearSearch }), externalActionPlacement: Placement.RIGHT }
            : { externalAction: React.createElement(MagnifierIcon, { className: "c-module-selector__search-icon" }), externalActionPlacement: Placement.LEFT };
        return (React.createElement("div", { className: "c-module-selector-spatial-desktop__section c-module-selector-spatial-desktop__search" },
            React.createElement(Input, { className: "c-module-selector-spatial-desktop__search-input", externalAction: externalAction, externalActionPlacement: externalActionPlacement, onChange: onSearchChange, placeholder: searchExpression, role: "searchbox", value: searchTerm })));
    }
    render() {
        return (React.createElement("div", { className: "c-module-selector-spatial-desktop" },
            this.renderSearchSpatialDesktop(),
            this.renderInnerModuleSpatialDesktop()));
    }
}
export default ModuleSelectorSpatialDesktop;
//# sourceMappingURL=module-selector-spatial-desktop.js.map